<template>
	<svg version="1.1"  v-bind:class="{turnOn: isTurnOn}"  id="Television" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		 viewBox="0 0 250 250" style="enable-background:new 0 0 250 250;" xml:space="preserve">
		<g>
			<path id="LowerCase" class="st0" d="M200.6,237H42.8v0.3c0,3.6,2.9,6.5,6.5,6.5h146.7c2.6,0,4.6-2.1,4.6-4.6V237z"/>
			<g id="Antennas">
				<path class="st1" d="M127,79.1l0.8,0.4c0.9,0.5,2.1,0.1,2.6-0.9l33.8-73.4c0.5-1,0.1-2.2-0.9-2.7l-0.8-0.4c-0.9-0.5-2.1-0.1-2.6,0.9l-33.8,73.4C125.6,77.4,126,78.6,127,79.1z"/>
				<path class="st1" d="M111.3,79l-0.8,0.4c-0.9,0.5-2.1,0.1-2.6-0.9L74.1,5.1c-0.5-1-0.1-2.2,0.9-2.7L75.8,2c0.9-0.5,2.1-0.1,2.6,0.9l33.8,73.4C112.6,77.3,112.2,78.5,111.3,79z"/>
			</g>
			<path id="UpperCase" class="st0" d="M182.1,84.4H67.3v-0.4c0-4.8,3.9-8.7,8.7-8.7h99.8c3.5,0,6.3,2.8,6.3,6.3V84.4z"/>
			<g id="Frame">
				<path class="st1" d="M195.2,238.7H54.8c-13.6,0-24.8-11.1-24.8-24.8V109.2c0-13.6,11.1-24.8,24.8-24.8h140.5c13.6,0,24.8,11.1,24.8,24.8v104.7C220,227.5,208.9,238.7,195.2,238.7z"/>
			</g>
			<g id="Buttons">
				<g>
					<path class="st0" d="M198.4,188.5h-4.4c-6.6,0-12-5.4-12-12v-36c0-6.6,5.4-12,12-12h4.4c6.6,0,12,5.4,12,12v36C210.4,183.1,205,188.5,198.4,188.5z"/>
				</g>
				<g>
					<ellipse class="st2" cx="202" cy="136.1" rx="4" ry="4.2"/>
					<ellipse class="st2" cx="189.9" cy="136.4" rx="4" ry="4.2"/>
					<ellipse class="st2" cx="189.9" cy="146.9" rx="4" ry="4.2"/>
					<ellipse class="st2" cx="202" cy="146.9" rx="4" ry="4.2"/>
					<ellipse class="st2" cx="189.9" cy="157.5" rx="4" ry="4.2"/>
					<ellipse class="st2" cx="189.9" cy="168" rx="4" ry="4.2"/>
					<ellipse class="st2" cx="189.9" cy="179.2" rx="4" ry="4.2"/>
					<ellipse class="st2" cx="202" cy="157.5" rx="4" ry="4.2"/>
					<ellipse class="st2" cx="202" cy="168" rx="4" ry="4.2"/>
					<ellipse class="st2" cx="202" cy="179.2" rx="4" ry="4.2"/>
				</g>
			</g>
			<g id="Monitor">
				<path class="st3" d="M59.2,216.6c-4.4,0-8-3.6-8-8v-93.9c0-4.4,3.6-8,8-8h102c4.4,0,8,3.6,8,8v93.9c0,4.4-3.6,8-8,8H59.2z"/>
				<path class="st0" d="M161.2,110.7c2.2,0,4,1.8,4,4v93.9c0,2.2-1.8,4-4,4h-102c-2.2,0-4-1.8-4-4v-93.9c0-2.2,1.8-4,4-4H161.2M161.2,102.7h-102c-6.6,0-12,5.4-12,12v93.9c0,6.6,5.4,12,12,12h102c6.6,0,12-5.4,12-12v-93.9C173.2,108.1,167.8,102.7,161.2,102.7L161.2,102.7z"/>
			</g>
			<g id="Sound">
				<g>
					<path class="st0" d="M202.1,200.3h-15.2c-0.4,0-0.6-0.3-0.6-0.6v-0.1c0-0.4,0.3-0.6,0.6-0.6h15.2c0.4,0,0.6,0.3,0.6,0.6v0.1C202.8,200.1,202.5,200.3,202.1,200.3z"/>
				</g>
				<g>
					<path class="st0" d="M205.7,203.7h-22.6c-0.3,0-0.6-0.3-0.6-0.6v-0.1c0-0.3,0.3-0.6,0.6-0.6h22.6c0.3,0,0.6,0.3,0.6,0.6v0.1C206.3,203.5,206,203.7,205.7,203.7z"/>
				</g>
				<g>
					<path class="st0" d="M205.5,207.2H183c-0.3,0-0.6-0.3-0.6-0.6v-0.1c0-0.3,0.3-0.6,0.6-0.6h22.6c0.3,0,0.6,0.3,0.6,0.6v0.1C206.1,206.9,205.9,207.2,205.5,207.2z"/>
				</g>
				<g>
					<path class="st0" d="M201.9,214.5h-15.2c-0.4,0-0.6-0.3-0.6-0.6v-0.1c0-0.4,0.3-0.6,0.6-0.6h15.2c0.4,0,0.6,0.3,0.6,0.6v0.1C202.5,214.2,202.2,214.5,201.9,214.5z"/>
				</g>
				<g>
					<path class="st0" d="M205.2,210.7h-22.6c-0.3,0-0.6-0.3-0.6-0.6V210c0-0.3,0.3-0.6,0.6-0.6h22.6c0.3,0,0.6,0.3,0.6,0.6v0.1C205.8,210.4,205.6,210.7,205.2,210.7z"/>
				</g>
			</g>
			<g id="Switch">
				<g>
					<path class="st0" d="M196.2,121.2c-3.8,0-6.9-3.4-6.9-7.5c0-4.1,3.1-7.5,6.9-7.5s6.9,3.4,6.9,7.5C203.1,117.9,200,121.2,196.2,121.2z"/>
					<path class="st4" d="M196.2,109.7c1.9,0,3.4,1.8,3.4,4s-1.5,4-3.4,4s-3.4-1.8-3.4-4S194.4,109.7,196.2,109.7 M196.2,102.7c-5.7,0-10.4,4.9-10.4,11s4.6,11,10.4,11s10.4-4.9,10.4-11S202,102.7,196.2,102.7L196.2,102.7z"/>
				</g>
				<g id="Switch1">
					<path class="st5" d="M196.4,112.7l4.4-2.4c0.3-0.1,0.6,0,0.7,0.2l0,0c0.1,0.3,0,0.6-0.2,0.8l-4.4,2.4c-0.3,0.1-0.6,0-0.7-0.2l0,0C196.1,113.2,196.2,112.8,196.4,112.7z"/>
				</g>
				<g id="Switch2" class="st6">
					<path class="st7" d="M197.9,119.3l-2.3-4.6c-0.1-0.3,0-0.6,0.2-0.8l0,0c0.3-0.1,0.6,0,0.7,0.2l2.3,4.6c0.1,0.3,0,0.6-0.2,0.8l0,0C198.3,119.7,198,119.6,197.9,119.3z"/>
				</g>
			</g>
			<g id="Colors" class="st6">
				<g class="st8">
					<rect x="49.8" y="104.7" class="st9" width="17.5" height="113.9"/>
				</g>
				<g class="st8">
					<rect x="67.3" y="104.7" class="st10" width="17.5" height="113.9"/>
				</g>
				<g class="st8">
					<rect x="84.8" y="104.7" class="st11" width="17.5" height="113.9"/>
				</g>
				<g class="st8">
					<rect x="102.4" y="104.7" class="st12" width="17.5" height="113.9"/>
				</g>
				<g class="st8">
					<rect x="119.9" y="104.7" class="st13" width="17.5" height="113.9"/>
				</g>
				<g class="st8">
					<rect x="137.4" y="104.7" class="st14" width="17.5" height="113.9"/>
				</g>
				<g class="st8">
					<rect x="155" y="104.7" class="st15" width="17.5" height="113.9"/>
				</g>
				<g class="st8">
					<path class="st0" d="M161.1,110.6c2.2,0,4,1.8,4,4v93.9c0,2.2-1.8,4-4,4h-102c-2.2,0-4-1.8-4-4v-93.9c0-2.2,1.8-4,4-4H161.1M161.1,102.6h-102c-6.6,0-12,5.4-12,12v93.9c0,6.6,5.4,12,12,12h102c6.6,0,12-5.4,12-12v-93.9C173.1,108,167.7,102.6,161.1,102.6L161.1,102.6z"/>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
   export default {
       name: "television",
	   props:{
		   isTurnOn: {
			   type: Boolean,
			   default: false,
		   }
	   }
   }
</script>

<style scoped lang="scss">
	/*Включено*/
	.turnOn{
		/*Цветные полосы, выключатель при включенном состоянии*/
		#Colors,#Switch2{display: block !important;}
		/*выключатель при выключенном состоянии*/
		#Switch1{display: none !important;}
	}
   .st0{fill:#442F28;}
   .st1{fill:#684B3E;}
   .st2{fill:#543F3B;}
   .st3{fill:#C4BD8A;}
   .st4{fill:#4C3631;}
   .st5{fill:#FCF8F7;}
   .st6{display:none;}
   .st7{display:inline;fill:#FCF8F7;}
   .st8{display:inline;}
   .st9{fill:#BA1C1C;}
   .st10{fill:#B75B1D;}
   .st11{fill:#B5B51F;}
   .st12{fill:#209DB2;}
   .st13{fill:#234AAD;}
   .st14{fill:#6524AA;}
   .st15{fill:#852493;}
</style>